var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "notification has-background-grey-darker",
          attrs: { id: "help" }
        },
        [
          _c("b", [_vm._v(_vm._s(_vm.$t("help")))]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v(_vm._s(_vm.$t("help.click")))]),
            _vm._v(" "),
            _c("li", [_vm._v(_vm._s(_vm.$t("help.timebar")))])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }